module.exports = __webpack_public_path__ + "static/AvenirNext-Regular-f62ec824125e3eb66f3bd8bdba538014.woff";